import React, { Suspense, lazy, ComponentType } from 'react';
import {useNavigate} from "react-router-dom";
import {Center, Loader, MantineProvider, Title} from '@mantine/core';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MemoryModel } from "./models/MemoryModel";

// General pages
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Portfolio } from "./pages/Portfolio";

// Authentication pages
import { Login } from "./pages/auth/Login";
import { Register } from "./pages/auth/Register";
import { Verify } from "./pages/auth/Verify";
import { Auth2FA } from "./pages/auth/2FA";
import { Enable2FA } from "./pages/auth/Enable2FA";

// Account pages
import { Account } from "./pages/account/Details";
import { AccountDashboard } from "./pages/account/Dashboard";

// Admin pages
import { PortfolioAdmin } from "./pages/admin/PortfolioAdmin";
import { UsersAdmin } from "./pages/admin/UsersAdmin";

// Error pages
import { NotFound } from './pages/errors/404';

// Other
import { Authentication } from "./logic/Authentication";

export default function App() {
    const model: MemoryModel = {
        ApiURL: "https://api.tomsw.uk",
        CFSiteKey: "0x4AAAAAAADsUWPv4ig1sdYO",
        AccessToken: "",
        TimeOfLastRefresh: 0,
        isSignedIn: false,
        URLBefore2FA: undefined,
        Router: useNavigate(),
        Cache: []
    }
    const Memory = React.useState(model);
    const [isChecking, setIsChecking] = React.useState(true);

    // See if the user is signed in by refreshing the JWT
    let auth = new Authentication({memory: Memory});

    async function checkSignedIn() {
        try {
            await auth.RefreshJwT();
        } catch (e) {
            // Do nothing
        } finally {
            setIsChecking(false); // Set to false after the check
        }
    }

    React.useEffect(() => {
        checkSignedIn();
    }, []);

    if (isChecking) {
        return (
            <Center style={{ height: '100vh' }}>
                <Loader size={125} color={'indigo'} variant="dots" />
            </Center>
        );
    }

    return (
        <Routes>
            // --- Generic routes ---

            <Route index element={<Home memory={Memory} />} />
            <Route path="about-me" element={<About memory={Memory} />} />
            <Route path="portfolio" element={<Portfolio memory={Memory} />} />
            // Authentication routes
            <Route path="login" element={<Login memory={Memory}/>} />
            <Route path="register" element={<Register memory={Memory}/>} />
            <Route path="verify" element={<Verify memory={Memory}/>} />
            <Route path="2fa" element={<Auth2FA memory={Memory}/>} />
            <Route path="2fa/enable" element={<Enable2FA memory={Memory}/>} />
            // Account routes
            <Route path="account" element={<Account memory={Memory} />} />
            <Route path="account/dashboard" element={<AccountDashboard memory={Memory} />} />

            // --- Admin routes ---

            <Route path="admin/portfolio" element={<PortfolioAdmin memory={Memory} />} />
            <Route path="admin/users" element={<UsersAdmin memory={Memory} />} />

            // Default route
            <Route path="*" element={<NotFound memory={Memory} />} />
        </Routes>
    );
}